
    <div class="in">
        <h3 class="title">{{rapportDetaille.titre}}</h3>
        <compliance-general-rapport-detaille-text *ngFor="let text of rapportDetaille.compteRenduText" [meta]="text" [extendedData]="extendedData"
            [controlId]="controlId" [exerciceId]="exerciceId" [projectId]="projectId" [destroy$]="destroy$"></compliance-general-rapport-detaille-text>
    </div>
